import { createSafeContext } from '@mews/framework';
import { AssignPropertiesFormValues } from '../schemas';

interface AssignPropertyContextValue {
    assignedPropertyGroupIds?: string[];
    assignedPropertyIds?: string[];
    assignProperties: (values: AssignPropertiesFormValues) => Promise<void>;
    unassignProperties: ({
        enterpriseIds,
        propertyGroupIds,
    }: {
        enterpriseIds?: string[];
        propertyGroupIds?: string[];
    }) => Promise<unknown>;
}

export const { AssignPropertyContextProvider, useAssignPropertyContext } = createSafeContext<
    'AssignPropertyContext',
    AssignPropertyContextValue
>('AssignPropertyContext');
